<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>用户管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item><a @click="jumpTo('/storeList')">门店管理</a></el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">

      <div class="contain_header clr">
        <el-form
          class="m-search"
          size='small'
          :model="filters"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label='店铺名称 '>
                <el-input
                  style="width:300px"
                  v-model="filters.title"
                  placeholder="请输入店铺名称"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="店铺状态">
                <el-select
                  clearable
                  v-model="filters.status"
                  placeholder="请选择"
                >
                  <el-option
                    label="显示"
                    value="1"
                  ></el-option>
                  <el-option
                    label="不显示"
                    value="2"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item>
                <el-button
                  type="primary"
                  @click="handleSearchM"
                >搜索</el-button>

                <el-button
                  v-show="showMap==1"
                  type="success"
                  @click="showMapInfo(2)"
                >地图模式</el-button>

                <el-button
                  v-show="showMap==2"
                  type="success"
                  @click="showMapInfo(1)"
                >列表模式</el-button>

                <el-button
                  style="margin-left:10px"
                  @click="excelOut"
                  type="primary"
                  size="small"
                >导出</el-button>

              </el-form-item>
            </el-col>
          </el-row>
          <el-row>

            <el-col :span="8">
              <el-form-item label='代理信息'>
                <el-input
                  style="width:300px"
                  v-model="filters.userInfo"
                  placeholder="请输入姓名或者手机号"
                >
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="5">
              <el-form-item
                label="所在省"
                prop="province"
              >
                <el-select
                  clearable
                  v-model="filters.province"
                  placeholder="请选择"
                  @change="changeCity"
                >
                  <el-option
                    v-for="option in provinceOptions"
                    :value="option"
                    :key='option'
                    :label="option"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">

              <el-form-item
                label="所在市"
                prop="city"
              >
                <el-select
                  clearable
                  v-model="filters.city"
                  placeholder="请选择"
                  @change="changeDistrict"
                >
                  <el-option
                    v-for="option in cityOptions"
                    :value="option"
                    :key='option'
                    :label="option"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">

              <el-form-item
                label="所在区"
                prop="district"
              >
                <el-select
                  clearable
                  v-model="filters.district"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="option in districtOption"
                    :value="option"
                    :key='option'
                    :label="option"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
      </div>

      <div
        v-show="showMap==1"
        class="contain_body"
      >
        <div class="contain_body_head">
        </div>
        <el-table
          :data="tableData"
          v-loading='tableDataLoading'
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >

          <el-table-column
            prop="username"
            label="代理姓名"
          >

          </el-table-column>

          <el-table-column
            prop="su_type"
            label="门店类型"
          >
          <template slot-scope="scope">
              <span v-if="scope.row.su_type == 1">素轩</span>
              <span v-else>煜美人</span>
            </template>

          </el-table-column>

          <el-table-column label="代理头像">
            <template slot-scope="scope">
              <img
                :src="scope.row.user_head"
                style="width:50px;"
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="user_tel"
            label="代理手机号"
          >
          </el-table-column>

          <el-table-column
            :formatter="formatterRoleType"
            prop="role_type"
            label="代理级别"
          >
          </el-table-column>

          <el-table-column
            prop="show_name"
            label="店铺名称"
          >
          </el-table-column>

          <el-table-column
            prop="telephone"
            label="店铺联系方式"
          >
          </el-table-column>

          <el-table-column
            prop="province"
            label="所在省"
          >
          </el-table-column>

          <el-table-column
            prop="city"
            label="所在市"
          >
          </el-table-column>

          <el-table-column
            prop="district"
            label="所在区"
          >
          </el-table-column>

          <el-table-column
            prop="address_detail"
            label="详细地址"
          >
          </el-table-column>

          <el-table-column
            prop="show_status"
            label="状态"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.show_status == 1">显示</span>
              <span v-if="scope.row.show_status == 2">不显示</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="create_time"
            label="创建时间"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            align='center'
          >
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.show_status == 1 && hasPower('40041991')"
                @click="upHouseStatus(scope.row, 2)"
                type="text"
              >不显示</el-button>

              <el-button
                v-if="scope.row.show_status == 2 && hasPower('40041991')"
                @click="upHouseStatus(scope.row, 1)"
                type="text"
              >显示</el-button>

            </template>
          </el-table-column>
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>

      </div>
      <div
        v-show="showMap==2"
        class="contain_body"
        style="display:flex;justify-content:center;padding-top:10px"
      >
        <div
          class="amap-wrapper1"
          id="container"
          tabindex="0"
        >

        </div>

      </div>

    </div>

  </el-main>

</template>


<script>
import AMap from "AMap";
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc";
var _ = require("lodash");
export default {
  name: "storeList",
  created() {},
  data() {
    return {
      tableDataLoading: false,
      addLoading: false,
      showMap: 1,
      cluster:null,
      filters: {
        title: null,
        userInfo: null,
        status: null,
        province: null,
        city: null,
        district: null,
        userType: null
      },
      dialogEditVisible: false,
      dialogBalanceVisible: false,
      addBalanceLoading: false,
      page_num: 1,
      map: null,
      keywords: "",
      provinceOptions: [],
      cityOptions: [],
      districtOption: [],
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      tableHeight:null
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    let that = this;
    this.loadmap();
    var provinceList = localStorage.getItem("provinceList")
    if (provinceList && provinceList != null)
    {
      that.provinceOptions = provinceList.split(',')
    } else
    {
      
    API.get_province({ token: localStorage.getItem("api_token") })
      .then(
        function(result) {
          if (result.key == 1000) {
            that.provinceOptions = result.result.list;
          } else if (result.key == 1001) {
            bus.$emit("goto", "/login");
          } else {
            that.$message.error({
              showClose: true,
              message: result.message || "登录失败",
              duration: 2000
            });
          }
        },
        function(err) {
          console.error(err);
          that.$message.error({
            showClose: true,
            message: err.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error) {
        console.error(error);
        that.$message.error({
          showClose: true,
          message: "请求出现异常",
          duration: 2000
        });
      });
    }
    this.handleSearch();
  },
  methods: {
    excelOut() {
      var that = this;
      var url =
        "/manager/user/pc/shop_list_excel?token=" +
        localStorage.getItem("api_token");
        if (that.filters.status) {
        url = url + "&role_type=" + that.filters.status;
      }
      if (that.filters.title) {
        url = url + "&keyword=" + that.filters.title;
      }
      if (that.filters.userInfo) {
        url = url + "&userInfo=" + that.filters.userInfo;
      }
      if (that.filters.keyword) {
        url = url + "&keyword=" + that.filters.keyword;
      }
      if (that.filters.city) {
        url = url + "&city=" + that.filters.city;
      }
      if (that.filters.district) {
        url = url + "&district=" + that.filters.district;
      }
      var provinceList = localStorage.getItem("provinceList")
      if (provinceList != null && provinceList != '')
      {
        url = url + "&province=" + provinceList;
      } else if (that.filters.province) {
        url = url + "&province=" + that.filters.province;
      }
      top.location.href = url;
    },
    formatterRoleType(row, column) {
      var word = "";
      if (row.role_type == -1) {
        word = "无";
      } else if (row.role_type == -0.5) {
        word = "康减系列vip会员";
      } else if (row.role_type == -0.4) {
        word = "康减系列高级会员";
      } else if (row.role_type == -0.3) {
        word = "康减系列荣誉会员";
      } else if (row.role_type == 0) {
        word = "VIP门店";
      } else if (row.role_type == 1) {
        word = "联盟店";
      } else if (row.role_type == 2) {
        word = "市代";
      } else if (row.role_type == 3) {
        word = "省代";
      } else if (row.role_type == 4) {
        word = "CEO";
      } else if (row.role_type == 1.1) {
        word = "康减系列市代";
      } else if (row.role_type == 2.1) {
        word = "康减系列省代";
      } else if (row.role_type == 3.1) {
        word = "康减系列CEO";
      } else if (row.role_type == 1.05) {
        return "优秀联盟店";
      } else if (row.role_type == 5) {
        return "总经销商";
      } else if (row.role_type == 2.2) {
        return "合伙人";
      } else if (row.role_type == 4.2) {
        return "董事";
      } else if (row.role_type == 5.1) {
        return "区域总监";
      } else if (row.role_type == 5.2) {
        return "城市加盟商";
      } else if (row.role_type == 4.8) {
        return "经销商";
      }
      if (row.special_status == 2) {
        word = word + '-' + '特殊';
      }
      return word;
    },
    showMapInfo(type) {
      this.showMap = type;
      if (type == 1) {
        this.handleSearch();
      } else {
        this.handleSearchAll();
      }
    },
    loadmap() {
      this.map = new AMap.Map("container", {
        resizeEnable: true,
        // center: [105, 34],
        zoom: 4
      });
      var that = this;
      this.map.plugin(["AMap.ToolBar"], function() {
        that.map.addControl(new AMap.ToolBar({
            // 简易缩放模式，默认为 false
            liteStyle: true
        }));
      });
    },
    showMarkers(list) {
      var that = this;
      if (that.cluster != null) {
        that.cluster.clearMarkers();
      }

      if (list == null || list.length == 0) {
        this.map.plugin(["AMap.MarkerClusterer"], function() {
          that.cluster = new AMap.MarkerClusterer(that.map, [], { gridSize: 80 });
        });
        return;
      }
      var points = [];
      for (var i=0; i<list.length; i++) {
        var point = {
          lnglat: [list[i].longitude, list[i].latitude],
          name: list[i].city,
          id: list[i].id,
          style: 0 // 该数据的样式取值styleObjectArr对应的样式索引
        };
        points.push(point);
      }
      var markers = [];
      for (var i = 0; i < points.length; i += 1) {
        markers.push(
          new AMap.Marker({
            position: points[i]["lnglat"],
            content:
              '<div style="background-color: hsla(180, 100%, 50%, 0.7); height: 24px; width: 24px; border: 1px solid hsl(180, 100%, 40%); border-radius: 12px; box-shadow: hsl(180, 100%, 50%) 0px 0px 1px;"></div>',
            offset: new AMap.Pixel(-15, -15)
          })
        );
      }
      var count = markers.length;
      this.map.plugin(["AMap.MarkerClusterer"], function() {
        that.cluster = new AMap.MarkerClusterer(that.map, markers, { gridSize: 80 });
      });
    },
    hasPower(power) {
      let powers = localStorage.getItem("powers");
      powers = JSON.parse(powers);
      var has = false;
      for (var i = 0; i < powers.length; i++) {
        if (powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
    changeCity() {
      if (this.filters.province != null) {
        var that = this;
        API.get_city({
          token: localStorage.getItem("api_token"),
          province: this.filters.province
        })
          .then(
            function(result) {
              if (result.key == 1000) {
                that.cityOptions = result.result.list;
              } else if (result.key == 1001) {
                bus.$emit("goto", "/login");
              } else {
                that.$message.error({
                  showClose: true,
                  message: result.message || "登录失败",
                  duration: 2000
                });
              }
            },
            function(err) {
              console.error(err);
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            console.error(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      }
    },
    changeDistrict() {
      if (this.filters.city != null) {
        var that = this;
        API.get_district({
          token: localStorage.getItem("api_token"),
          city: this.filters.city
        })
          .then(
            function(result) {
              if (result.key == 1000) {
                that.districtOption = result.result.list;
              } else if (result.key == 1001) {
                bus.$emit("goto", "/login");
              } else {
                that.$message.error({
                  showClose: true,
                  message: result.message || "登录失败",
                  duration: 2000
                });
              }
            },
            function(err) {
              console.error(err);
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            console.error(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      }
    },

    formatterStatus(row, column) {
      if (row.status == 1) {
        return "可用";
      } else if (row.status == 2) {
        return "禁用";
      }
    },

    upHouseStatus(row, status) {
      if (status == 2) {
        let that = this;
        this.$confirm("确定后，app端将搜索不到该店铺", "确定不显示该店铺吗?", {
          type: "info"
        })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id,
              show_status: status
            };
            API.up_shop_show(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "操作成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else if (status == 3) {
      } else if (status == 1) {
        let that = this;
        this.$confirm("确定后，app端将可以搜索到该店铺", "确定显示该店铺吗?", {
          type: "warning"
        })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id,
              show_status: status
            };
            API.up_shop_show(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "操作成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      }
    },
    handleSearchM(){
      if (this.showMap == 1) {
        this.handleSearch();
      } else {
        this.handleSearchAll();
      }
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    handleSearchAll() {
      this.page_num = 0;
      this.search();
    },
    search() {
      let that = this;
      let params = {
        page_num: that.page_num,
        page_size: that.page_size,
        token: localStorage.getItem("api_token")
      };
      if (that.filters.title) {
        params.keyword = that.filters.title;
      }
      if (that.filters.userInfo) {
        params.userInfo = that.filters.userInfo;
      }
      if (that.filters.status) {
        params.status = that.filters.status;
      }
      if (that.filters.province) {
        params.province = that.filters.province;
      }
      if (that.filters.city) {
        params.city = that.filters.city;
      }
      if (that.filters.district) {
        params.district = that.filters.district;
      }
      var provinceList = localStorage.getItem("provinceList")
      if (that.filters.province && that.filters.province != null) {
        params.province = that.filters.province;
      } else if (provinceList != null && provinceList != '')
      {
        params.province = provinceList;
      }
      that.tableDataLoading = true;
      API.shop_list(params)
        .then(
          function(result) {
            that.tableDataLoading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].create_time = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                }
              }
              that.tableData = result.result.list;
              if (that.page_num == 0) {
                that.showMarkers(result.result.list);
              }
            }
          },
          function(err) {
            that.tableDataLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.tableDataLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    }
  }
};
</script>

<style>
.amap-wrapper1 {
  padding: 30px;
  width: 1100px;
  height: 500px;
}
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/storeList.vue